import { render, staticRenderFns } from "./userJurisdiction.vue?vue&type=template&id=52a20016&scoped=true"
import script from "./userJurisdiction.vue?vue&type=script&lang=js"
export * from "./userJurisdiction.vue?vue&type=script&lang=js"
import style0 from "./userJurisdiction.vue?vue&type=style&index=0&id=52a20016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a20016",
  null
  
)

export default component.exports